import axios from 'axios';

const shouldRetryRemoteRequest = (error) => {
  const status = error?.response?.status;
  if (!status) return true;
  return status >= 500;
};

const shouldFallbackToControllersRoute = (error) => {
  const status = error?.response?.status;
  return shouldRetryRemoteRequest(error) || status === 404;
};

const remoteGet = async (path, params = {}) => {
  try {
    return await axios.get(`/api/remote/android-tv/${path}`, { params });
  } catch (err) {
    if (!shouldFallbackToControllersRoute(err)) throw err;
    return axios.get(`/controllers/api/remote/android-tv/${path}`, { params });
  }
};

const remotePost = async (path, payload = {}) => {
  try {
    return await axios.post(`/api/remote/android-tv/${path}`, payload);
  } catch (err) {
    // Pairing changes relay state; retry only when the primary route is absent.
    if (err?.response?.status !== 404) throw err;
    return axios.post(`/controllers/api/remote/android-tv/${path}`, payload);
  }
};

const remotePut = async (path, payload = {}) => {
  try {
    return await axios.put(`/api/remote/android-tv/${path}`, payload);
  } catch (err) {
    if (!shouldFallbackToControllersRoute(err)) throw err;
    return axios.put(`/controllers/api/remote/android-tv/${path}`, payload);
  }
};

const remoteDelete = async (path, payload = {}) => {
  try {
    return await axios.delete(`/api/remote/android-tv/${path}`, { data: payload });
  } catch (err) {
    if (!shouldFallbackToControllersRoute(err)) throw err;
    return axios.delete(`/controllers/api/remote/android-tv/${path}`, { data: payload });
  }
};

export const loadAndroidTvRemoteStatus = async (deviceId, targetHost = '') => {
  const response = await remoteGet('status', {
    deviceId,
    ...(targetHost ? { targetHost } : {}),
  });
  return response.data || null;
};

export const saveAndroidTvRemoteTarget = async ({
  deviceId,
  targetHost,
  targetName,
  previousTargetHost,
}) => {
  const response = await remotePut('target', {
    deviceId,
    targetHost,
    targetName,
    previousTargetHost,
  });
  return response.data || null;
};

export const deleteAndroidTvRemoteTarget = async ({
  deviceId,
  targetHost,
}) => {
  const response = await remoteDelete('target', {
    deviceId,
    targetHost,
  });
  return response.data || null;
};

export const startAndroidTvRemotePairing = async ({
  deviceId,
  targetHost,
  targetName,
}) => {
  const response = await remotePost('pair/start', {
    deviceId,
    targetHost,
    targetName,
  });
  return response.data || null;
};

export const confirmAndroidTvRemotePairing = async ({
  deviceId,
  sessionId,
  code,
  targetName,
}) => {
  const response = await remotePost('pair/confirm', {
    deviceId,
    sessionId,
    code,
    targetName,
  });
  return response.data || null;
};

export const sendAndroidTvRemoteAction = async ({
  deviceId,
  targetHost,
  action,
}) => {
  const response = await remotePost('action', {
    deviceId,
    targetHost,
    action,
  });
  return response.data || null;
};
